<div class="modal-header py-2">
    <h2 class="mb-0">Cancel subscription</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="cancel()"></span>
</div>
<div class="modal-body">
    <p>Not happy with TablesReady? Please 
        <a href="mailto:support@tablesready.com?subject=Not happy with TablesReady!" target="_blank" rel="noopener noreferrer" class="font-weight-bold">
        let us know first</a>! We want to help.
    </p>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary mr-2"
        id="confirm-subscription-cancel"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm cancel subscription"
        type="submit"
        [disabled]="inProgress"
        (click)="cancelSubscription()"
    >Start cancellation
    </button>
    <button type="button" class="btn btn-danger" [disabled]="inProgress" (click)="cancel()">Never mind!</button>
</div>
